import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'

import Logo from 'assets/images/logo.svg'

import { AudiencesIcon, ConnectionsIcon, EventsIcon, HomeIcon } from 'app/common/presentation/icons'

import { Profile } from '../Profile'
import styles from './Header.module.scss'

const Header = () => {
  const { t } = useTranslation('header')
  const location = useLocation()

  return (
    <header className={styles.header}>
      <Link to={'/'}>
        <Logo className={styles.logo} />
      </Link>
      <div className={styles.menu}>
        <ul>
          <li className={location.pathname === '/' ? styles.selected : undefined}>
            <Link to={'/'}>
              <HomeIcon className={styles.icon} />
              {t('menu.home')}
            </Link>
          </li>
          <li className={location.pathname.includes('/audiences') ? styles.selected : undefined}>
            <Link to={'/audiences'}>
              <AudiencesIcon className={styles.icon} />
              {t('menu.audiences')}
            </Link>
          </li>
          <li className={location.pathname.includes('/connections') ? styles.selected : undefined}>
            <Link to={'/connections/installed'}>
              <ConnectionsIcon className={styles.icon} />
              {t('menu.connections')}
            </Link>
          </li>
          <li className={location.pathname.includes('/events') ? styles.selected : undefined}>
            <Link to={'/events'}>
              <EventsIcon className={styles.icon} />
              {t('menu.events')}
            </Link>
          </li>
        </ul>
      </div>
      <Profile />
    </header>
  )
}

export default Header
